<div class="flex" style="margin-top: 15px;" *ngIf="integrationModules && integrationModules.length > 0 && !loadingModules">
  <div class="card dataview-container">
    <p-table
      [(first)]="first"
      [(rows)]="rows"
      [value]="integrationModules"
      [totalRecords]="integrationModules.length"
      [responsive]="true"
      [paginator]="true"
      [rowsPerPageOptions]="[10,25,50]"
      styleClass="p-datatable-striped"
      dataKey="dataKey"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="selection-column-width"></th>
          <th pSortableColumn="integrationIdentifier">
            {{'attribute.integrationIdentifier' | transloco}}<p-sortIcon field="integrationIdentifier"></p-sortIcon></th>
          <th pSortableColumn="integrationCode">
            {{'attribute.integrationCode' | transloco}}<p-sortIcon field="integrationCode"></p-sortIcon></th>
          <th pSortableColumn="decoder.name">
            {{'model.decoder' | transloco}}<p-sortIcon field="decoder.name"></p-sortIcon></th>
          <th pSortableColumn="encoder.name">
            {{'model.encoder' | transloco}}<p-sortIcon field="encoder.name"></p-sortIcon></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-module let-expanded="expanded">
        <tr *ngIf="!loadingModules">
          <td>
            <span class="p-column-title bold">{{'common.expand' | transloco}}</span>
            <button
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
              [pRowToggler]="module"
              pButton
              pRipple
              class="p-button-text p-button-rounded p-button-plain"
              type="button"
            ></button>
          </td>
          <td>
            <span class="p-column-title bold">{{'attribute.integrationIdentifier' | transloco}}</span>
            {{module.integrationIdentifier}}
          </td>
          <td>
            <span class="p-column-title bold">{{'attribute.integrationCode' | transloco}}</span>
            {{module.integrationCode}}
          </td>
          <td>
            <span class="p-column-title bold">{{'model.decoder' | transloco}}</span>
            <p [class.font-italic]="!module.decoder?.name">
              {{module.decoder?.name ?? ('empty.decoder' | transloco)}}
            </p>
          </td>
          <td>
            <span class="p-column-title bold">{{'model.encoder' | transloco}}</span>
            <p [class.font-italic]="!module.encoder?.name">
              {{module.encoder?.name ?? ('empty.encoder' | transloco)}}
            </p>
          </td>
        </tr>
        <tr *ngIf="loadingModules">
          <td class="row-height-md"><p-skeleton height="1em"></p-skeleton></td>
          <td class="row-height-md"><p-skeleton height="1em"></p-skeleton></td>
          <td class="row-height-md"><p-skeleton height="1em"></p-skeleton></td>
          <td class="row-height-md"><p-skeleton height="1em"></p-skeleton></td>
          <td class="row-height-md"><p-skeleton height="1em"></p-skeleton></td>
        </tr>
      </ng-template>
      <ng-template pTemplate="rowexpansion" let-module>
        <tr>
          <td colspan="5">
            <div class="grid">
              <div class="col-6">
                <b>{{'attribute.additionalInfo' | transloco}}:</b>
              </div>
              <div class="col-6 left-border">
                <b>{{'attribute.technicalDetails' | transloco}}:</b>
              </div>
              <div class="col-6">
                <ngx-json-viewer *ngIf="module.additionalInfo" [json]="module.additionalInfo"></ngx-json-viewer>
                <div *ngIf="!module.additionalInfo"><i>{{'empty.additionalInfo' | transloco}}</i></div>
              </div>
              <div class="col-6 left-border">
                <ngx-json-viewer *ngIf="module.technicalDetails" [json]="module.technicalDetails"></ngx-json-viewer>
                <div *ngIf="!module.technicalDetails"><i>{{'empty.technicalDetails' | transloco}}</i></div>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <div class="flex">
          <div class="my-auto">
            <div *ngIf="totalModules == 0">
              {{'pagination.empty' | transloco}}
            </div>
            <div *ngIf="totalModules > 0">
              {{'pagination.showing' | transloco}} {{first+1}}
              {{'pagination.to' | transloco}} {{(first+rows) >= totalModules ? totalModules : (first+rows)}}
              {{'pagination.of' | transloco}} {{totalModules}}
              {{(totalModules > 1 ? 'pagination.entries':'pagination.entry') | transloco}}
            </div>
          </div>
        </div>
      </ng-template>
    </p-table>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="integrationModules && integrationModules.length == 0">
  <div class="card w-full">
    <p class="text-xl text-center p-6 font-italic">{{'empty.integrationModules' | transloco}}</p>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="!integrationModules || loadingModules">
  <div class="card w-full">
    <app-table-skeleton [rows]="14"></app-table-skeleton>
  </div>
</div>
